import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Method from "@/components/Method";
import Mentor from "@/components/Mentor";
import Testimonials from "@/components/Testimonials";
import Program from "@/components/Program";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import WhatsAppButton from "@/components/WhatsAppButton";
import NoiseOverlay from "@/components/NoiseOverlay";
import Loader from "@/components/Loader";

function Landing() {
  useLenis();
  return (
    <div className="App bg-cream text-ink relative" data-testid="landing-page">
      <Loader />
      <NoiseOverlay />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Method />
        <Mentor />
        <Testimonials />
        <Program />
        <FAQ />
        <Contact />
      </main>
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
